import { MDBCol, MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'
import load from '../statics/gif/load.gif'

const Loading:React.FC = ()=>{
    return<>
    <MDBContainer>
        <MDBRow>
            <MDBCol>
                <img style={{
                    display:'block',
                    marginLeft:'auto', 
                    marginRight: 'auto', 
                    }}  
                src={load} 
                alt='loading' 
                width={45} 
                height={45} />
            </MDBCol>
        </MDBRow>
    </MDBContainer>
    </>
}

export default Loading